import React from 'react';
import PropTypes from 'prop-types';
import ClusterMultiSelect from 'app/components/ClusterMultiSelect';

import useClusterMultiSelectProps from './useClusterMultiSelectProps';

export default function BulkDeployClusterMultiSelect({ disabled }) {
  const props = useClusterMultiSelectProps();

  return <ClusterMultiSelect {...props} disabled={disabled} data-test-id="clusterMultiSelect" />;
}

BulkDeployClusterMultiSelect.propTypes = {
  disabled: PropTypes.bool,
};
